import classNames from 'classnames';

export default function PaperFooter({
  children,
  nestedInPaperContent = false,
  className,
}: {
  children?: React.ReactNode;
  nestedInPaperContent?: boolean;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'yst-mt-8 yst-flex yst-items-center yst-justify-end yst-gap-6 yst-rounded-bl-lg yst-rounded-br-lg yst-border-t yst-border-slate-200 yst-bg-slate-50 yst-px-8 yst-py-6',
        {
          'yst-mb-[-2rem] yst-ml-[-2rem] yst-mr-[-2rem]': nestedInPaperContent,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
